/**
 * useFeedback (CHAP-262) — React Query hooks for tenant feedback list + mutate.
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiDelete } from '../lib/api.js';
import type { FeedbackList } from '../../shared/types.js';

export interface SubmitFeedbackBody {
  text: string;
  name?: string;
  email?: string;
  page?: string;
}

export function useFeedbackList(slug: string, enabled: boolean) {
  return useQuery<FeedbackList, Error>({
    queryKey: ['feedback', slug],
    queryFn: () => apiGet<FeedbackList>(`/api/c/${slug}/feedback`),
    enabled,
    retry: false,
  });
}

export function useSubmitFeedback(slug: string) {
  const qc = useQueryClient();
  return useMutation<{ id: string; emailStatus: string }, Error, SubmitFeedbackBody>({
    mutationFn: (body) => apiPost(`/api/c/${slug}/feedback`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['feedback', slug] }),
  });
}

export function useDeleteFeedback(slug: string) {
  const qc = useQueryClient();
  return useMutation<unknown, Error, string>({
    mutationFn: (id) => apiDelete(`/api/c/${slug}/feedback/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['feedback', slug] }),
  });
}
